import React, {useEffect} from 'react';

import Content from './Content';
import styles from './App.module.css';

function calcValues() {
  const centerContent = document.getElementById('center-content');
  const centerFold = document.getElementById('center-fold');

  if (!centerContent || !centerFold) {
    return;
  }

  const overflowHeight = Math.max(
    centerContent.clientHeight - centerFold.clientHeight,
    0,
  );

  document.body.style.height = `${overflowHeight + window.innerHeight}px`;
}

function syncFoldTransforms() {
  const foldsContent = Array.from(
    document.querySelectorAll('[data-fold-content="true"]'),
  );
  const scroll = -(
    document.documentElement.scrollTop || document.body.scrollTop
  );

  foldsContent.forEach(content => {
    content.style.transform = `translateY(${scroll}px)`;
  });
}

function App() {
  useEffect(() => {
    const recalcLayout = () => {
      calcValues();
      syncFoldTransforms();
    };

    const recalcAfterHashChange = () => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(recalcLayout);
      });
    };

    let frameId = null;
    let resizeObserver = null;

    const tick = () => {
      syncFoldTransforms();
      frameId = window.requestAnimationFrame(tick);
    };

    window.addEventListener('resize', recalcLayout);
    window.addEventListener('hashchange', recalcAfterHashChange);

    const centerContent = document.getElementById('center-content');
    if (centerContent && typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(recalcLayout);
      resizeObserver.observe(centerContent);
    }

    recalcAfterHashChange();
    frameId = window.requestAnimationFrame(tick);

    return () => {
      window.removeEventListener('resize', recalcLayout);
      window.removeEventListener('hashchange', recalcAfterHashChange);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
    };
  }, []);

  return (
    <div className={styles.all}>
      <div className={styles.wrapper3d}>
        <div className={`${styles.fold} ${styles.foldTop}`}>
          <div className={styles.foldAlign}>
            <div data-fold-content="true">
              <Content />
            </div>
          </div>
        </div>
        <div className={styles.fold} id="center-fold">
          <div className={styles.foldAlign}>
            <div data-fold-content="true" id="center-content">
              <Content />
            </div>
          </div>
        </div>
        <div className={`${styles.fold} ${styles.foldBottom}`}>
          <div className={styles.foldAlign}>
            <div data-fold-content="true">
              <Content />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
